import { createContext, useContext } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

const GoogleMapsCtx = createContext({ isLoaded: false });

// Sabit referans — her render'da yeni dizi oluşturmasın
const LIBRARIES = ['places'];

export function GoogleMapsProvider({ children }) {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
    libraries: LIBRARIES,
    language: 'tr',
    region: 'TR',
  });

  return (
    <GoogleMapsCtx.Provider value={{ isLoaded }}>
      {children}
    </GoogleMapsCtx.Provider>
  );
}

export const useGoogleMaps = () => useContext(GoogleMapsCtx);
